<app-page-modifications>
  <app-header class="full-width"></app-header>
  <main id="content" class="js-content" role="main">
    <form #inputAssistantForm="ngForm">
      <div class="grid-row">
        <div class="column-full">
          <div *ngIf="formSubmitted && inputAssistantForm.invalid" class="error-summary" role="alert" aria-labelledby="error-summary" tabindex="0">
            <h2 class="heading-medium error-summary-heading aa-lead-size" id="error-summary">
              You need to fix the error on this page before continuing
            </h2>
            <p class="aa-copy-size">
              See highlighted errors below
            </p>
            <div class="error-summary-list aa-copy-size">
              <ng-container *ngTemplateOutlet="errorSummary; context:{control: inputAssistantForm.controls.inputAssistantFirstName, focus: 'inputAssistantFirstName', field: 'first name'}"></ng-container>
              <ng-container *ngTemplateOutlet="errorSummary; context:{control: inputAssistantForm.controls.inputAssistantLastName, focus: 'inputAssistantLastName', field: 'last name'}"></ng-container>
            </div>
          </div>
          <header class="page-header" tabindex="0">
            <h1 class="heading-xlarge aa-title-size">Your settings</h1>
          </header>
          <p class="aa-lead-size" tabindex="0">
            You have the following settings on your check
          </p>
          <ol class="list list-number aa-copy-size">
            <li tabindex="0" *ngIf="config.colourContrast"><a routerLink="/colour-choice">Edit colour</a> of page</li>
            <li tabindex="0" *ngIf="config.fontSize"><a routerLink="/font-choice">Edit size of words and numbers</a></li>
            <li tabindex="0" *ngIf="config.inputAssistance" [ngClass]="{'extra-space': !config.practice}">
              Input assistant
                <div *ngIf="!config.practice" class="panel panel-border-wide padding-left no-padding aa-contrast-border">
                  <div tabindex="0">Please enter the first and last name of the input assistant that will be helping you through the check</div>
                  <br>
                  <div tabindex="0" [ngClass]="{ 'form-group': true, 'form-group-error': formSubmitted && inputAssistantFirstName.invalid}">
                    <label for="inputAssistantFirstName" class="form-label aa-copy-size aa-contrast">
                      First name of input assistant
                      <ng-container *ngTemplateOutlet="error; context:{control: inputAssistantFirstName, field: 'first name'}"></ng-container>
                    </label>
                    <input id="inputAssistantFirstName" #inputAssistantFirstName="ngModel" ngModel required maxlength="128" [pattern]="validationPattern"
                            [ngClass]="{ 'form-control': true, 'form-control-error': formSubmitted && inputAssistantFirstName.invalid}" type="text"
                            name="inputAssistantFirstName" spellcheck="false" autocorrect="off" autocomplete="off" class="aa-contrast aa-contrast-border aa-copy-size">
                  </div>
                  <div tabindex="0" [ngClass]="{ 'form-group': true, 'form-group-error': formSubmitted && inputAssistantLastName.invalid}">
                    <label for="inputAssistantLastName" class="form-label aa-copy-size aa-contrast">
                      Last name of input assistant
                      <ng-container *ngTemplateOutlet="error; context:{control: inputAssistantLastName, field: 'last name'}"></ng-container>
                    </label>
                    <input id="inputAssistantLastName" #inputAssistantLastName="ngModel" ngModel required maxlength="128" [pattern]="validationPattern"
                            [ngClass]="{ 'form-control': true, 'form-control-error': formSubmitted && inputAssistantLastName.invalid}" type="text"
                            name="inputAssistantLastName" spellcheck="false" autocorrect="off" autocomplete="off" class="aa-contrast aa-contrast-border aa-copy-size">
                  </div>
                </div>
            </li>
            <li tabindex="0" *ngIf="config.nextBetweenQuestions">Pause - ‘next’ button between questions</li>
            <li tabindex="0" *ngIf="config.questionReader">Audio version</li>
            <li tabindex="0" *ngIf="config.numpadRemoval">Remove number pad</li>
            <li tabindex="0" *ngIf="config.audibleSounds">Time alert</li>
          </ol>
          <p  tabindex="0" class="aa-copy-size">
            If you need to add or remove any settings, please tell your teacher and
            <a routerLink="/sign-out">sign out</a>.
          </p>
          <button type="button" class="button aa-button-size aa-contrast-button" (click)="onClick()" id="next">Next</button>
        </div>
      </div>
    </form>
  </main>
</app-page-modifications>
<ng-template #errorSummary let-control="control" let-field="field" let-focus="focus">
    <p class="aa-copy-size" tabindex="0" *ngIf="control.errors && (control.errors.required || control.errors.maxlength)">
      <label [for]="focus">Enter a {{field}} in no more than 128 characters</label>
    </p>
    <p class="aa-copy-size" tabindex="0" *ngIf="control.errors && control.errors.pattern">
      <label [for]="focus">Enter a {{field}} without special characters</label>
    </p>
</ng-template>
<ng-template #error let-control="control" let-field="field">
    <span *ngIf="formSubmitted && control.errors && (control.errors.required || control.errors.maxlength)" class="error-message aa-copy-size">
      Enter a {{field}} in no more than 128 characters
    </span>
    <span *ngIf="formSubmitted && control.errors && control.errors.pattern" class="error-message aa-copy-size">
      Enter a {{field}} without special characters
    </span>
</ng-template>
